// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__3KT0i","header":"PatientQuestionnaire_header__2A9wR","info":"PatientQuestionnaire_info__367TR"};